import {
    InsuranceDetailTitleInfoArticleWrapper,
    InsuranceDetailTitleInfoListWrapper,
    InsuranceDetailTitleInfoSection,
} from '$components/insurance/my/detail/InsuranceDetailTitleInfo'
import {InsuranceDetailTitleContactLayer} from '$components/insurance/my/detail/InsuranceDetailTitleLayer'
import InsuranceDetailWrapper from '$components/insurance/my/detail/InsuranceDetailWrapper'
import useFreeInsuranceDetail from '$hooks/insurance/my/free/useFreeInsuranceDetail'

export default function InsuranceDetailFreeTitle() {
    const {hasValidInsurances, regionName, name, freeInsuCategory, tel, websiteLink} = useFreeInsuranceDetail()

    return (
        <InsuranceDetailWrapper typeWhite>
            <InsuranceDetailTitleInfoArticleWrapper noTab>
                <InsuranceDetailTitleInfoSection company={regionName} name={name} freeInsuCategory={freeInsuCategory} />
                <InsuranceDetailTitleInfoListWrapper>
                    <InsuranceDetailTitleContactLayer
                        nClkPrefix={'fr'}
                        auCode={`insu_my_detail_free_${hasValidInsurances ? 'registered' : 'unregistered'}_inquiry`}
                        layerInfo={{
                            title: regionName,
                            homeUrl: websiteLink ?? '',
                            serviceCenterTel: tel ?? '',
                            freeInsuCategory,
                        }}
                    />
                </InsuranceDetailTitleInfoListWrapper>
            </InsuranceDetailTitleInfoArticleWrapper>
        </InsuranceDetailWrapper>
    )
}
